export var cardInlineInfoStyle=`margin-top:3px;`
export var cardTitleStyle=`font-size:14px;display:inline-block;margin-right:5px;cursor:pointer;`
export var cardContentStyle=`font-size:14px;font-weight:bolder;display:inline-block;`